import {AfterViewInit, Component, DestroyRef, ElementRef, OnInit, ViewChild, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {empty} from '../../../functions';
import {ValidationService} from '../../../shared/services/validation.service';
import {JobService, jobpostingHours} from '../../.../../../shared/services/job.service';
import {LocaleService} from '../../../shared/services/locale.service';
import {InterestService} from '../../../shared/services/interest.service';
import {ModelJobposting} from '../../../model/model.jobposting';
import {EducationService} from '../../../shared/services/education.service';
import {Observable, of, Subscription} from 'rxjs';
import {alertMessages, AlertService} from '../../../shared/services/alert.service';
import {catchError} from 'rxjs/operators';
import {CompanyService} from '../../../shared/services/company.service';
import {faSave, faSpinner, faDownload, faChevronUp, faChevronDown} from '@fortawesome/free-solid-svg-icons';
import bsCustomFileInput from 'bs-custom-file-input';
import {ApiService} from '../../../shared/services/api.service';
import {ModalService} from '../../../shared/services/modal.service';
import {MatchService} from '../../../shared/services/match.service';

import {jobpostingTypes} from '../../.../../../shared/services/job.service';
import { ClassicEditor, EditorConfig } from 'ckeditor5';

@Component({
    selector: 'app-modal-company-profile-assignment',
    templateUrl: './modal-company-profile-assignment.component.html',
    styleUrls: ['./modal-company-profile-assignment.component.scss'],
    standalone: false
})
export class ModalCompanyProfileAssignmentComponent implements OnInit, AfterViewInit {

  private readonly destroyRef = inject(DestroyRef);

  isLoading = false;

  Object = Object;

  // data container for modal
  public data:any;

  // Add subscriptions to use
  areaofinterestSubscription:Subscription = new Subscription();
  educationLevelsSubscription:Subscription = new Subscription();

  isProcessing = false;

  // Icons to use
  faSave = faSave;
  faSpinner = faSpinner;
  faDownload = faDownload;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;

  jobpostingHours = jobpostingHours;

  public Editor = ClassicEditor;
  public editorConfig: EditorConfig = {
    removePlugins: ['Title', 'Image', 'LinkImage', 'ImageInsert', 'ImageUpload'],
    language: this.locale.getCurrentLanguage(),
    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
    heading: {
      options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
      ]
    }
  };

  public profile:any = {
    id: ''
  }

  /** entity data model */
  public entity:ModelJobposting = {
    id: '',
    companyId: '',
    company: {
      id: '',
      status: '',
      name: '',
      registrationNumber: '',
      visitAddress: {
        street: '',
        number: '',
        numberSuffix: '',
        city: '',
        postalCode: '',
        country: '',
      },
      phoneNumber: '',
      address_city: '',
      description: '',
      descriptionEn: '',
      descriptionDe: '',
      descriptionFr: '',
      descriptionPt: '',
      uniqueText: '',
      uniqueTextEn: '',
      uniqueTextDe: '',
      uniqueTextFr: '',
      uniqueTextPt: '',
      opportunitiesText: '',
      opportunitiesTextEn: '',
      opportunitiesTextDe: '',
      opportunitiesTextFr: '',
      opportunitiesTextPt: '',
      sectorId: '',
      sectorName: '',
      numberOfEmployees: '',
      websiteUri: '',
      twitterUri: '',
      facebookUri: '',
      linkedInUri: '',
      instagramUri: '',
      googleUri: '',
      avatarUri: '',
      coverPhotoUri: '',
      isCurrentUserFavorite: false
    },
    trademarkId: '',
    trademark: {
      id: '',
      name: '',
      description: '',
      avatarUri: '',
      coverPhotoUri: ''
    },
    contactPersonId: '',
    contactPerson: {
      id: '',
      emailAddress: '',
      firstName: '',
      lastName: '',
      phoneNumber: ''
    },
    isCurrentUserFavorite: false,
    currentUserMatchPercentage: 0,
    title: '',
    location: '',
    description: '',
    address: {
      street: '',
      number: '',
      numberSuffix: '',
      postalCode: '',
      city: '',
      country: '',
    },
    requirements: '',
    termsOfEmployment: '',
    additionalInfo: '',
    immediatelyAvailable: false,
    startDate: null,
    deadline: null,
    hours: '',
    hoursPerWeek: 0,
    isExperienceDesired: false,
    externalReferenceUri: '',
    status: '',
    type: jobpostingTypes.Assignment, // use fixed value
    areaOfInterests: <any> [],
    educationLevels: <any> [],
    documents: <any> [],
    related_jobs: <any> [],
    regions: [],
    jobPostingTargetGroups: [],
  };

  // Attachment file upload to handle
  attachmentChangedEvent: any = '';
  attachmentFileName = '';
  attachmentFileUrl = '';

  // All trademark entity results
  trademarkResults: any[] = [];

  /**
   * Wizard with steps
   */
  public stepWizard = {
    currentStep:<number> 1,
    steps: <any> [
      {
        step: 1,
        title: 'General',
        validation : {
          validated: false,
          fields : {
            entity: {
              type: {
                regex: 'required',
                error: false
              },
              title: {
                regex: 'required',
                error: false
              },


            }
          }
        }
      },
      {
        step: 2,
        title: 'Match',
        validation : {
          validated: false,
          fields : {
            entity: {

            }
          }
        }
      },
      {
        step: 3,
        title: 'Requirements',
        validation : {
          validated: false,
          fields : {
            entity: {
              hours: {
                regex: 'required',
                error: false
              },

            }
          }
        }
      },
      {
        step: 4,
        title: 'Education',
        validation : {
          validated: false,
          fields : {
            entity: {
            }
          }
        }
      },
      {
        step: 5,
        title: 'Contact',
        validation : {
          validated: false,
          fields : {
            entity: {
              address: {
                street: {
                  regex: 'required',
                  error: false
                },
                number: {
                  regex: 'required',
                  error: false
                },
                postalCode: {
                  regex: 'required',
                  error: false
                },
                city: {
                  regex: 'required',
                  error: false
                },
                country: {
                  regex: 'required',
                  error: false
                }
              }
            }
          }
        }
      }
    ]
  }

  companyAccounts:any[] = [];

  areaOfInterests: any[] = [];
  educationLevels: any[] = [];
  groupedEducationLevels: any = {};

  private maxCompanyCultureCompetencies = 5;
  private maxPersonalityCompetencies = 2;

  // General match competency data to select for criterion
  matchCompetency: any = [];
  matchCompetencyCompanyCulture: any = [];
  matchCompetencyPersonality: any = [];

  // Match criterion to set for company profile
  public matchcriterion:any = {
    companyCultureFactor: 0,
    personalityFactor: 0,
    areaOfInterestFactor: 0,
    companyCultureCompetencies: [],
    personalityCompetencies: []
  };

  // Competency group namings
  public companyCultureCompetencies = 'companyCultureCompetencies';
  public personalityCompetencies = 'personalityCompetencies';

  excludedRegions: string[] = ['EU'];

  // @ts-ignore
  @ViewChild('modalBody') modalBody: ElementRef;

  /**
   * Constructor
   *
   * @param activeModal
   * @param companyService
   * @param locale
   * @param validationService
   * @param api
   * @param alertService
   * @param jobService
   * @param modal
   * @param interestService
   * @param educationService
   * @param matchService
   */
  constructor(public activeModal: NgbActiveModal,
              public companyService: CompanyService,
              public locale: LocaleService,
              private validationService: ValidationService,
              private api: ApiService,
              private alertService: AlertService,
              public jobService: JobService,
              public modal: ModalService,
              public interestService: InterestService,
              private educationService: EducationService,
              private matchService: MatchService) {


  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.profile = this.data.profile;
    this.entity = Object.assign(<ModelJobposting>this.entity, this.data.entity);

    if (!this.entity.address) {
      this.entity.address = {
        street: this.entity.company.visitAddress.street,
        number: this.entity.company.visitAddress.number,
        numberSuffix: this.entity.company.visitAddress.numberSuffix,
        postalCode: this.entity.company.visitAddress.postalCode,
        city: this.entity.company.visitAddress.city,
        country: this.entity.company.visitAddress.country
      };
    }

    // Set company data
    this.entity.companyId = this.data.profile.id;

    // Set all data to use for form
    this.initializeData();

  }

  /**
   * Ng after view init
   */
  ngAfterViewInit() {
    bsCustomFileInput.init();
  }

  /**
   * Initialize data
   */
  initializeData() {

    this.isLoading = true;

    const loadPromises = {
      areaOfInterests: new Promise( (resolve, reject) => {

        // Set area of interest data
        if (!empty(this.interestService.areaOfInterests)) {
          this.areaOfInterests = this.interestService.areaOfInterests;
          resolve(true);
        } else {
          this.areaofinterestSubscription = this.interestService.areaOfInterestsSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (result:any) => {
            this.areaOfInterests = this.interestService.areaOfInterests;
            resolve(true);
          });
        }

      }),
      educationLevels: new Promise( (resolve, reject) => {

        // Set area of interest data
        if (!empty(this.educationService.educationLevels)) {
          this.educationLevels = this.educationService.educationLevels;
          // Group education levels by region / country
          this.groupEducationLevels();
          resolve(true);
        } else {
          this.educationLevelsSubscription = this.educationService.educationLevelsSubject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (result:any) => {
            this.educationLevels = this.educationService.educationLevels;
            // Group education levels by region / country
            this.groupEducationLevels();
            resolve(true);
          });
        }

      }),
      tradeMarks: new Promise((resolve, reject) => {

        // Get trademarks of company
        this.companyService.apiGetTrademarks(this.data.profile.id).pipe(catchError(this.handleError('apiGetTrademarks', false))).subscribe( (result:any) => {

          if (result) {
            this.trademarkResults = Object.assign([], result);
          }

          resolve(true);

        });

      }),
      accounts: new Promise( (resolve, reject) => {
        // Get all company accounts
        this.companyService.apiGetCompanyAccounts(this.profile.id).pipe(catchError(this.handleError('apiGetCompanyAccounts', false))).subscribe( (result:any) => {

          if (result) {
            this.companyAccounts = result;
          } else {
            this.companyAccounts = [];
          }

          resolve(true);

        });
      }),
      matchcompetencies: new Promise( (resolve, reject) => {

        if (this.matchService.competencies) {
          this.matchCompetency = Object.assign([], this.matchService.competencies);
          this.matchCompetencyCompanyCulture = this.getMatchCompetenciesByType('CompanyCulture');
          this.matchCompetencyPersonality = this.getMatchCompetenciesByType('Personality');
          resolve(true);

        } else {
          this.matchService.apiGetMatchtestCompetencies().pipe(catchError(this.handleError('apiGetMatchtestCompetencies', false))).subscribe( (response:any) => {

            if (response) {
              if (response.hasOwnProperty('data')) {
                this.matchCompetency = Object.assign([], response.data);

                this.matchCompetencyCompanyCulture = this.getMatchCompetenciesByType('CompanyCulture');
                this.matchCompetencyPersonality = this.getMatchCompetenciesByType('Personality');

              }
            }

            resolve(true);

          });
        }
      }),
      matchcriterion: new Promise( (resolve, reject) => {

        if (!empty(this.entity.id)) {
          this.jobService.apiGetMatchcriterion(this.entity.id, null).pipe(catchError(this.handleError('apiGetMatchcriterion', false))).subscribe( (response) => {

            if (response) {
              this.matchcriterion = Object.assign({}, response);
            }

            resolve(true);

          });
        } else {
          resolve(true);
        }
      })
    };

    Promise.all([loadPromises.areaOfInterests, loadPromises.educationLevels, loadPromises.tradeMarks, loadPromises.accounts, loadPromises.matchcompetencies, loadPromises.matchcriterion]).then( (values) => {

      // Check values and then close or warn
      if (values[0] === true && values[1] === true && values[2] == true && values[3] == true && values[4] == true && values[5] == true) {
        this.isLoading = false;
      } else {
        this.isLoading = false;
      }

    });

  }

  /**
   * Group education levels per region
   */
  groupEducationLevels() {

    const groups:any = {};

    if (this.educationLevels.length > 0) {

      // Collect all possible education level regions
      for (const ed of this.educationLevels) {

        // Add region
        if (ed.hasOwnProperty('regions')) {
          for (const region of ed['regions']) {
            if (!groups.hasOwnProperty(region)) {
              if (!this.excludedRegions.includes(region)) groups[region] = []; // skip possible excluded regions to be grouped, by default EU
            }
          }
        }
      }

      // Now load all education levels into correct region container
      for (const region of Object.keys(groups)) {
        for (const ed of this.educationLevels) {
          if (ed['regions'].indexOf(region) > -1) {
            groups[region].push(ed);
          }
        }
      }
    }

    this.groupedEducationLevels = Object.assign(<any>{}, groups);
  }

  /**
   * Toggle education level in entity collection
   *
   * @param $id
   */
  toggleEducationLevel($id: string) {

    let found:string|boolean = false;

    if (this.entity.educationLevels.length > 0) {

      for (const i in this.entity.educationLevels) {
        const educationLevel = this.entity.educationLevels[i];
        if (educationLevel['id'] == $id) {
          found = i;
        }
      }
    }

    if (found !== false) {
      this.entity.educationLevels.splice(found, 1);
    }
    else {

      // Find education level data and set it
      for (const el of this.educationLevels) {
        if (el.id == $id) {

          const educationLevel = {
            id: $id,
            name: el.name,
            educationProfiles: [],
            phases: []
          };
          this.entity.educationLevels.push(educationLevel);

        }
      }

    }

  }

  /**
   * Check if a education level is already selected in existing entity
   *
   * @param $id
   */
  existsEducationLevel($id: string) {

    let found:string|boolean = false;

    if (this.entity.educationLevels.length > 0) {

      for (const i in this.entity.educationLevels) {
        const educationLevel = this.entity.educationLevels[i];
        if (educationLevel['id'] == $id) {
          found = i;
        }
      }
    }

    if (found !== false) {
      return true;
    }
    else {
     return false;
    }
  }

  /**
   * Toggle education level in entity collection
   *
   * @param $id
   */
  toggleEducationLevelProfile($educationLevelId:string, $educationProfile:any) {

    let found = false;
    if (this.entity.educationLevels.length > 0) {

      for (const i in this.entity.educationLevels) {
        const educationLevel = this.entity.educationLevels[i];
        if (educationLevel['id'] == $educationLevelId) {

          if (educationLevel['educationProfiles'].length > 0) {

            for (const j in educationLevel['educationProfiles']) {
              const $profile = educationLevel['educationProfiles'][j];

              if ($profile['id'] == $educationProfile['id']) {
                found = true;
                this.entity.educationLevels[i]['educationProfiles'].splice(j, 1);
              }
            }

          }

          if (!found) {
            this.entity.educationLevels[i]['educationProfiles'].push($educationProfile);
          }


          } else {

          }

        }

      } else {

    }

  }

  /**
   * Check if a education level is already selected in existing entity
   *
   * @param $id
   */
  existsEducationLevelProfile($educationLevelId: string, $educationProfile: any) {

    if (this.entity.educationLevels.length > 0) {

      for (const i in this.entity.educationLevels) {
        const educationLevel = this.entity.educationLevels[i];
        if (educationLevel['id'] == $educationLevelId) {

          if (educationLevel['educationProfiles'].length > 0) {
            for (const profile of educationLevel['educationProfiles']) {
              if (profile['id'] == $educationProfile['id']) {
                return true;
              }
            }
          }

        }
      }
    }

    return false;
  }

  /**
   * Toggle education level in entity collection
   *
   * @param $id
   */
  toggleEducationLevelPhase($educationLevelId:string, $phase:string) {

    if (this.entity.educationLevels.length > 0) {

      for (const i in this.entity.educationLevels) {
        const educationLevel = this.entity.educationLevels[i];
        if (educationLevel['id'] == $educationLevelId) {

          if (educationLevel.phases.indexOf($phase) !== -1) {
            this.entity.educationLevels[i].phases.splice(this.entity.educationLevels[i].phases.indexOf($phase), 1);
          } else {
            this.entity.educationLevels[i].phases.push($phase);
          }

        }
      }
    }
  }

  /**
   * Check if a education level is already selected in existing entity
   *
   * @param $id
   */
  existsEducationLevelPhase($educationLevelId: string, $phase: string) {

    if (this.entity.educationLevels.length > 0) {

      for (const i in this.entity.educationLevels) {
        const educationLevel = this.entity.educationLevels[i];
        if (educationLevel['id'] == $educationLevelId) {

          if (educationLevel.phases.indexOf($phase) !== -1) {
            return true;
          }

        }
      }
    }

    return false;
  }

  /**
   * Show validation error
   *
   * Determine if a validation error needs to be visible to client
   *
   * @param stepNumber
   * @param $entity
   * @param $entityProperty
   */
  showValidationError(stepNumber: number, $entity: string, $entityProperty: string, $entitySub: string = '') {

    const index = stepNumber - 1;

    if ($entitySub) {

      if (!this.stepWizard.steps[index]['validation']['fields'][$entity][$entitySub].hasOwnProperty($entityProperty)) {
        return false;
      }

      if (this.stepWizard.steps[index]['validation']['validated'] && this.stepWizard.steps[index]['validation']['fields'][$entity][$entitySub][$entityProperty]['error'] === true) {
        return true;
      } else {
        return false;
      }

    } else {

      if (!this.stepWizard.steps[index]['validation']['fields'][$entity].hasOwnProperty($entityProperty)) {
        return false;
      }

      if (this.stepWizard.steps[index]['validation']['validated'] && this.stepWizard.steps[index]['validation']['fields'][$entity][$entityProperty]['error'] === true) {
        return true;
      } else {
        return false;
      }

    }

  }

  /**
   * Go to next step and validate
   */
  nextStep() {
    const totalSteps = this.stepWizard.steps.length;

    if (this.stepWizard.currentStep < totalSteps) {
      const valid = this.validateWizard(this.stepWizard.currentStep);
      if (valid) {

        // Scroll back to top automatically
        this.modalBody.nativeElement.scrollTop = 0;

        // Check step to process data
        switch(this.stepWizard.currentStep) {
          case 1:
            // Normal procedure
            this.stepWizard.currentStep++;
            break;

          default:
            this.stepWizard.currentStep++;

            break;
        }
      }

    } else {
      const valid = this.validateWizard();
      this.stepWizard.currentStep++;
    }

  }

  /**
   * Go to previous step and validate
   *
   */
  previousStep() {

    if (this.stepWizard.currentStep > 1) {
      // Scroll back to top automatically
      this.modalBody.nativeElement.scrollTop = 0;
      this.stepWizard.currentStep--;
    }

  }

  /**
   * Valdiate wizard step(s)
   */
  validateWizard($step:any = null) {
    let valid = true;
    const self:any = this;

    if (this.stepWizard.steps.length > 0) {

      for (const s in this.stepWizard.steps) {

        // Only validate based on step number
        if (!empty($step) && $step !== this.stepWizard.steps[s]['step']) continue;

        let stepValid = true;

        if (!empty(this.stepWizard.steps[s].validation) && this.stepWizard.steps[s]['validation'].hasOwnProperty('fields')) {

          // Set entity data selectors
          const $entitySelectors = ['entity', 'entity.address'];

          // Check entity columns
          for (const $entitySelector of $entitySelectors) {

            const $entitySplit = $entitySelector.split('.');

            if ($entitySplit.length > 1) {

              const $entitySelectorMain = $entitySplit[0];
              const $entitySelectorSub = $entitySplit[1];

              if ( this.stepWizard.steps[s]['validation']['fields'].hasOwnProperty($entitySelectorMain) && this.stepWizard.steps[s]['validation']['fields'][$entitySelectorMain].hasOwnProperty($entitySelectorSub) ) {

                for (const key in this.stepWizard.steps[s]['validation']['fields'][$entitySelectorMain][$entitySelectorSub]) {

                  if (!empty(this.stepWizard.steps[s]['validation']['fields'][$entitySelectorMain][$entitySelectorSub][key])) {

                    const entity = this.stepWizard.steps[s]['validation']['fields'][$entitySelectorMain][$entitySelectorSub][key];

                    if (entity.hasOwnProperty('regex') ) {
                      const value = self[$entitySelectorMain][$entitySelectorSub][key];
                      const regPattern = entity['regex'];

                      // Set validation flags
                      if (!this.validationService.regexValidation(regPattern, value)) {
                        this.stepWizard.steps[s]['validation']['fields'][$entitySelectorMain][$entitySelectorSub][key]['error'] = true;

                        stepValid = false;
                        valid = false;
                      } else {
                        this.stepWizard.steps[s]['validation']['fields'][$entitySelectorMain][$entitySelectorSub][key]['error'] = false;
                      }

                    }
                  }
                }
              }

            } else {

              if ( this.stepWizard.steps[s]['validation']['fields'].hasOwnProperty($entitySelector) ) {

                for (const key in this.stepWizard.steps[s]['validation']['fields'][$entitySelector]) {

                  if (!empty(this.stepWizard.steps[s]['validation']['fields'][$entitySelector][key])) {

                    const entity = this.stepWizard.steps[s]['validation']['fields'][$entitySelector][key];

                    if (entity.hasOwnProperty('regex') ) {
                      const value = self[$entitySelector][key];
                      const regPattern = entity['regex'];

                      // Set validation flags
                      if (!this.validationService.regexValidation(regPattern, value)) {
                        this.stepWizard.steps[s]['validation']['fields'][$entitySelector][key]['error'] = true;

                        stepValid = false;
                        valid = false;
                      } else {
                        this.stepWizard.steps[s]['validation']['fields'][$entitySelector][key]['error'] = false;
                      }

                    }
                  }
                }
              }

            }

          }

          // Set validation flags for step
          this.stepWizard.steps[s]['validation']['valid'] = stepValid;
          this.stepWizard.steps[s]['validation']['validated'] = true;
        }

        if (!empty($step)) return stepValid;

      }

    }

    const validationErrors = this.getValidationErrorCount($step);

    if (validationErrors > 0) {
      valid = false;

      this.navigationAfterValidation();

    } else {
      valid = true;
    }

    return valid;
  }

  /**
   * Count the invalid steps of validation
   */
  getValidationErrorCount($step = null) {
    let counter = 0;
    for (const s in this.stepWizard.steps) {

      // Only validate based on step number
      if (!empty($step) && $step !== this.stepWizard.steps[s]['step']) continue;

      if (this.stepWizard.steps[s]['validation']['valid'] === false) counter++;
    }
    return counter;
  }

  /**
   * Navigate to a step where a validation error occurred
   */
  navigationAfterValidation() {

    for (const s in this.stepWizard.steps) {

      if (this.stepWizard.steps[s]['validation']['valid'] === false) {
        this.stepWizard.currentStep = this.stepWizard.steps[s]['step'];
        return true;
      }

    }

    return false;
  }

  /**
   * Delete a document of a job posting
   *
   * @param $documentId
   */
  deleteJobPostingDocument($documentId:string) {

    this.modal.Confirm('Delete', 'Are you sure you want to delete this?', {}, [], {}, false).then( (confirm) => {
      if (confirm === true) {
        this.jobService.apiDeleteJobPostingDocument(this.entity.id, $documentId).pipe(catchError(this.handleError('apiDeleteJobPostingDocument', false))).subscribe( (result) => {

          if (result !== false){

            // Remove document from listing
            for (const d in this.entity.documents) {
              const document = this.entity.documents[d];
              if (document.id == $documentId) {
                this.entity.documents.splice(d, 1);
              }
            }

            this.alertService.success(alertMessages.successDataRemoved);

          }

        });
      } else {

      }
    }).catch( (error) => {

    });

  }


  /**
   * Apply automatic correction of values when a factor number is changed
   * @param $factor
   */
  onFactorChange($factor: string) {
    let totalFactor = 0;
    switch ( $factor) {

      case 'companyCultureFactor':
        totalFactor = this.matchcriterion.companyCultureFactor + this.matchcriterion.personalityFactor + this.matchcriterion.areaOfInterestFactor;
        if (totalFactor > 100) {
          this.matchcriterion.companyCultureFactor = 100 - (this.matchcriterion.areaOfInterestFactor + this.matchcriterion.personalityFactor)
        }

        break;

      case 'personalityFactor':
        totalFactor = this.matchcriterion.companyCultureFactor + this.matchcriterion.personalityFactor + this.matchcriterion.areaOfInterestFactor;
        if (totalFactor > 100) {
          this.matchcriterion.personalityFactor = 100 - (this.matchcriterion.companyCultureFactor + this.matchcriterion.areaOfInterestFactor)
        }

        break;

      case 'areaOfInterestFactor':
        totalFactor = this.matchcriterion.companyCultureFactor + this.matchcriterion.personalityFactor + this.matchcriterion.areaOfInterestFactor;
        if (totalFactor > 100) {
          this.matchcriterion.areaOfInterestFactor = 100 - (this.matchcriterion.companyCultureFactor + this.matchcriterion.personalityFactor)
        }

        break;

    }
  }

  /**
   * Get match competencies by type
   *
   * Uses matchCompetency to collect
   *
   * @param $type
   */
  getMatchCompetenciesByType($type: string) {
    const result:any = [];

    for (const comp of this.matchCompetency) {

      if (comp['type'] == $type) {
        result.push(comp);
      }
    }

    return result;
  }

  /**
   * Get a single competency item by id
   *
   * @param $competence_id
   */
  getCompetencyItem($competence_id: string) {

    if (this.matchCompetency.length > 0) {
      for (const competency of this.matchCompetency) {
        if (competency.id == $competence_id) {
          return competency;
        }
      }
    }


    return null;
  }

  /**
   * Toggle selected match criterion competency
   *
   * @param $competence_id
   * @param $type 'companyCultureCompetencies' | 'personalityCompetencies'
   */
  toggleMatchtestCompetence($competence_id: string, $type: string) {

    if (!this.hasMatchtestCompetenceValue($competence_id, $type)) {

      if ($type == 'companyCultureCompetencies' && this.matchcriterion[$type].length >= this.maxCompanyCultureCompetencies) return;
      if ($type == 'personalityCompetencies' && this.matchcriterion[$type].length >= this.maxPersonalityCompetencies) return;

      const $competencyItem = this.getCompetencyItem($competence_id);
      if ($competencyItem) {
        this.matchcriterion[$type].push({
          matchCompetencyId: $competencyItem.id,
          name: $competencyItem.name,
          description: $competencyItem.description,
          sort: ( this.matchcriterion[$type].length + 1)
        });
      }

    } else {

      // Remove item
      for (const i in this.matchcriterion[$type]) {
        if (this.matchcriterion[$type][i]['matchCompetencyId'] == $competence_id) {
          this.matchcriterion[$type].splice(i, 1);
        }
      }

    }

  }

  /**
   * Determine if a match competency of a specific type is set or not
   *
   * @param $competence_id
   * @param $type 'companyCultureCompetencies' | 'personalityCompetencies'
   */
  hasMatchtestCompetenceValue($competence_id: string, $type: string) {

    let found:any = false;
    if (empty($type)) return found;

    if (this.matchcriterion.hasOwnProperty($type)) {

      for (const competency of this.matchcriterion[$type]) {

        if ($competence_id == competency.matchCompetencyId ) {
          found = true;
        }
      }

    }

    return found;
  }

  /**
   * Sort the array of match criterion based on sort value
   *
   * @param $type
   */
  sortMatchcriterionCompetencies( $type: string) {

    this.matchcriterion[$type].sort((a1:any, a2:any) => {
      if(a1.sort < a2.sort) return -1;
      if(a1.sort > a2.sort) return 1;
      return 0;
    });

  }

  /**
   * Move a match criterion competency up in sorting
   *
   * @param $key
   * @param $type
   */
  moveMatchcriterionCompetencyUp($key: number, $type: string) {

    if ($key > 0) {
      const currentSort = this.matchcriterion[$type][$key]['sort'];
      const newSort = parseInt(this.matchcriterion[$type][$key]['sort'], 10) - 1;

      this.matchcriterion[$type][$key]['sort'] = newSort;
      this.matchcriterion[$type][$key - 1]['sort'] = currentSort;

      this.sortMatchcriterionCompetencies($type);

    }
  }

  /**
   * Move a match criterion competency down in sorting
   *
   * @param $key
   * @param $type
   */
  moveMatchcriterionCompetencyDown($key: number, $type: string) {

    if ($key < this.matchcriterion[$type].length - 1) {
      const currentSort = this.matchcriterion[$type][$key]['sort'];
      const newSort = parseInt(this.matchcriterion[$type][$key]['sort'], 10) + 1;

      this.matchcriterion[$type][$key]['sort'] = newSort;
      this.matchcriterion[$type][$key + 1]['sort'] = currentSort;

      this.sortMatchcriterionCompetencies($type);

    }
  }


  /**
   * Save
   *
   * @constructor
   */
  Save() {

    const validated = this.validateWizard();
    if (!validated) return;

    this.isProcessing = true;

    // Update
    if (!empty(this.entity.id)) {

      this.jobService.apiUpdateJobPosting(this.entity.id, this.entity).pipe(catchError(this.handleError('apiUpdateJobPosting', false))).subscribe( (result) => {

        if (result !== false) {

          // Check for files to upload
          // Upload possible files
          const jobPromises = {
            // Attachment promise
            attachmentPromis : new Promise((resolve, reject) => {

              if (this.attachmentFileName) {
                // Create multipart form data of base64 and upload to correct API endpoint

                fetch(this.attachmentFileUrl)
                  .then(res => res.blob())
                  .then(blob => {
                    const fd = new FormData();
                    const file = new File([blob], this.attachmentFileName);
                    fd.append('file', file);

                    // Finally upload the file
                    const API_URL = this.api.getApiUrl() + '/jobposting/' + this.entity.id + '/documents' ;
                    const headers = this.api.getUploadHeaders();
                    fetch(API_URL, {method: 'POST', headers: headers, body: fd})
                      .then((res) => {

                        this.isProcessing = false;

                        if (res.status == 200) {
                          resolve(true);

                        } else {
                          // Some error
                          resolve(false);
                        }


                      }).catch( (error) => {
                      this.isProcessing = false;
                    })

                  });

              }
              else {
                resolve(true);
              }

            }),
            matchcriterionPromise : new Promise((resolve, reject) => {

              this.jobService.apiUpdateMatchcriterion(this.entity.id, this.matchcriterion).pipe(catchError(this.handleError('apiUpdateMatchcriterion', false))).subscribe( (result) => {

                if (result !== false)  resolve(true);
                else reject(false);
              });

            }),
          };

          Promise.all([jobPromises.attachmentPromis, jobPromises.matchcriterionPromise]).then( (values) => {

            this.isProcessing = false;

            // Check values and then close or warn
            if (values[0] === true && values[1] === true) {
              this.alertService.success(alertMessages.successDataSaved);
              this.activeModal.close(true);
            } else {
              this.alertService.errorWithReport(new Error('jobPosting save subtask failed'), 'companyAssignment:save');
            }

          });
        } else {
          this.isProcessing = false;
        }

      });

    }
    // Create
    else {

      this.jobService.apiAddJobPosting(this.entity).pipe(catchError(this.handleError('apiAddJobposting', false))).subscribe( (result:any) => {

        if (result !== false) {

          const entity_id = result['id'];


          // Check for files to upload
          // Upload possible files
          const jobPromises = {
            // Attachment promise
            attachmentPromis : new Promise((resolve, reject) => {

              if (this.attachmentFileName) {
                // Create multipart form data of base64 and upload to correct API endpoint

                fetch(this.attachmentFileUrl)
                  .then(res => res.blob())
                  .then(blob => {
                    const fd = new FormData();
                    const file = new File([blob], this.attachmentFileName);
                    fd.append('file', file);

                    // Finally upload the file
                    const API_URL = this.api.getApiUrl() + '/jobposting/' + entity_id + '/documents' ;
                    const headers = this.api.getUploadHeaders();
                    fetch(API_URL, {method: 'POST', headers: headers, body: fd})
                      .then((res) => {

                        this.isProcessing = false;

                        if (res.status == 200) {
                          resolve(true);

                        } else {
                          // Some error
                          resolve(false);
                        }


                      }).catch( (error) => {
                      this.isProcessing = false;
                    })

                  });

              }
              else {
                resolve(true);
              }

            }),
            matchcriterionPromise : new Promise((resolve, reject) => {

              this.jobService.apiUpdateMatchcriterion(entity_id, this.matchcriterion).pipe(catchError(this.handleError('apiUpdateMatchcriterion', false))).subscribe( (result) => {

                if (result !== false)  resolve(true);
                else reject(false);
              });

            }),
          }; // File promises

          Promise.all([jobPromises.attachmentPromis, jobPromises.matchcriterionPromise]).then( (values) => {

            this.isProcessing = false;

            // Check values and then close or warn
            if (values[0] === true && values[1] === true) {
              this.alertService.success(alertMessages.successDataSaved);
              this.activeModal.close(true);
            } else {
              this.alertService.errorWithReport(new Error('jobPosting save subtask failed'), 'companyAssignment:save');
            }

          });


        } else {
          this.isProcessing = false;
        }

      });
    }

  }

  /**
   * Event handler for selecting attachment file
   *
   * @param event
   */
  attachmentFileChangeEvent(event: any) {

    this.attachmentChangedEvent = event;

    // Search for file name when input file changes
    if (this.attachmentChangedEvent.target.files && this.attachmentChangedEvent.target.files.length > 0) {

      for (let i = 0; i < this.attachmentChangedEvent.target.files.length; i++) {
        const file = this.attachmentChangedEvent.target.files[i];
        this.attachmentFileUrl = URL.createObjectURL(file);
        this.attachmentFileName = file.name;
      }
    }

  }

  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation:string = '', result?: T) {
    return (error: any): Observable<T> => {

      // Handle given operation
      switch (operation) {

        case 'apiGetStudentprofileCurrent':
          // Do not perform any action, profile could be non-existing
          break;

        default:
          this.alertService.errorWithReport(error, `companyAssignment:${operation}`);
          break;

      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
